<main class="payment ic-page" *ngIf="content">
  <header class="payment__header">
    <h1 class="payment__header--title">{{ content.title }}</h1>
  </header>
  <app-external-cart-list [payment]="espPayment"></app-external-cart-list>
  <app-choose-payment-method (submitPaymentMethod)="onSubmit($event)"></app-choose-payment-method>

  <app-loaders fullScreen="true" [type]="'splash'" *ngIf="splashEnabled"></app-loaders>
</main>
